// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1VQb8","selected":"Chip_selected__3e_k6"};